import { Link } from 'react-router-dom';

interface Article {
  id: number;
  title: string;
  slug: string;
  category: string;
  categoryName: string;
  cover: string;
  excerpt: string;
  author: string;
  date: string;
  readTime: string;
  views: number;
  tags: string[];
}

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link to={`/article/${article.id}`} className="group block cursor-pointer">
      <article className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300">
        <div className="aspect-[16/9] overflow-hidden">
          <img
            src={article.cover}
            alt={article.title}
            title={article.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
        </div>
        <div className="p-4 md:p-5">
          <div className="flex items-center gap-2 mb-2 flex-wrap">
            <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
              {article.categoryName}
            </span>
            <span className="text-xs text-foreground-400">{article.readTime}</span>
          </div>
          <h3 className="font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors text-sm line-clamp-2 mb-2">
            {article.title}
          </h3>
          <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
            {article.excerpt}
          </p>
          <div className="flex items-center justify-between text-xs text-foreground-400">
            <div className="flex items-center gap-1.5">
              <i className="ri-user-line"></i>
              <span>{article.author}</span>
            </div>
            <div className="flex items-center gap-1.5">
              <i className="ri-eye-line"></i>
              <span>{article.views.toLocaleString()}</span>
            </div>
          </div>
        </div>
      </article>
    </Link>
  );
}